import { apiGet, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getWidgetDataURI, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseHighYieldDividend {
    private container: HTMLElement;
    private config: WidgetConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private currentChart: any;
    private widgetResizeObserver: ResizeObserver | null = null;
    private currentInterval: string = '1w';
    private lastFetchedAt: Date | null = null;
    private outsideClickHandler: ((ev: MouseEvent) => void) | null = null;

    constructor(config: WidgetConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            this.updateDisplay();
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }

    private fetchSymbols(): Array<{ value: string; label: string }> {
        return [
            { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
            { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
            { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
            { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
            { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
        ];
    }

    private getDefaultConfig(): Partial<WidgetConfig> {
        const symbols = this.fetchSymbols();
        return {
      headerPinned: true,
            symbol: symbols[0].value,
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true,
            p_min_yield: 4,
            p_top_n: 10,
            p_sort_by: 'yield',
            p_exclude_special_dividends: true
        };
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
        this.createWidget();
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) widget.classList.add('loading');
        await this.attachStyles();
        this.currentData = null;
        this.updateDisplay();
        this.emit('ready', {});
        this.config.onReady?.();
        this.setupChart();
        cancelSelectEvent(this.shadowRoot);
    }

    private createWidget(): void {
        let themeClass = 'defaultDarkMode';
      let dataTheme = 'default-dark';
      
      if (this.config.theme === 'white') {
        themeClass = 'whiteMode';
        dataTheme = 'white';
      } else if (this.config.theme === 'black') {
        themeClass = 'blackMode';
        dataTheme = 'black';
      } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
        const widgetHtml = `
            <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
                <div class="headTop">
                    <h4 class="title market">${this.getTitleIconSvg()}
                        High Yield Dividend
                    </h4>
                    <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<tooltip-wrapper id="lastUpdatedTooltip"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.625 6.625C0.625 7.41293 0.780195 8.19315 1.08172 8.9211C1.38325 9.64905 1.82521 10.3105 2.38236 10.8676C2.93951 11.4248 3.60095 11.8667 4.3289 12.1683C5.05685 12.4698 5.83707 12.625 6.625 12.625C7.41293 12.625 8.19315 12.4698 8.9211 12.1683C9.64905 11.8667 10.3105 11.4248 10.8676 10.8676C11.4248 10.3105 11.8667 9.64905 12.1683 8.9211C12.4698 8.19315 12.625 7.41293 12.625 6.625C12.625 5.0337 11.9929 3.50758 10.8676 2.38236C9.74242 1.25714 8.2163 0.625 6.625 0.625C5.0337 0.625 3.50758 1.25714 2.38236 2.38236C1.25714 3.50758 0.625 5.0337 0.625 6.625Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.625 3.2915V6.62484L8.625 8.62484" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> </svg><tooltip><span>Last Updated</span><strong>N/A</strong></tooltip></tooltip-wrapper><div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div></div>
                </div>
                <div class="inBody">
                    <div class="optionsRow" data-testing-id="options-row">
                        <div class="item"></div>
                        <span></span>

                        <div class="filtersBox sideBar hidden">
                            <div class="item">
                                <div class="filters">
                                    <label>Min Yield</label>
                                    <input type="number" class="filter-min-yield" min="0" step="0.1" style="width:72px;margin-left:6px" value="${this.config.p_min_yield}" data-testing-id="min-yield-input" />
                                </div>
                            </div>
                            <div class="item" data-testing-id="filter-top-n">
                                <label>Top</label>
                                <select class="filter-top-n" data-testing-id="top-n-select">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="custom">Custom</option>
                                </select> 
                                <input type="number" class="filter-top-n-custom hidden" min="1" style="width:72px;margin-left:6px" placeholder="Custom" data-testing-id="top-n-custom" />
                            </div>
                            <div class="item" data-testing-id="filter-sort-by">
                                <label>Sort</label>
                                <select class="filter-sort-by" data-testing-id="sort-by-select">
                                    <option value="yield">Yield</option>
                                    <option value="adj_dividend">Dividend Amount</option>
                                    <option value="payment_date">Payment Date</option>
                                </select>  
                            </div>
                            <div class="item" data-testing-id="filter-exclude-special">
                                <div class="checkBoxField">
                                    <input class="filter-exclude-special" ${this.config.p_exclude_special_dividends ? 'checked' : ''} type="checkbox" data-testing-id="exclude-special-checkbox" />
                                    <label>Exclude Special <i>✓</i></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="chartDv" id="topIndexContainer" data-testing-id="top-index-container"></div>
                </div>
            </div>
        `;
        this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);
        const minYieldEl = this.shadowRoot.querySelector('.filter-min-yield') as HTMLInputElement | null;
        const topNEl = this.shadowRoot.querySelector('.filter-top-n') as HTMLSelectElement | null;
        const topNCustomEl = this.shadowRoot.querySelector('.filter-top-n-custom') as HTMLInputElement | null;
        const sortByEl = this.shadowRoot.querySelector('.filter-sort-by') as HTMLSelectElement | null;
        const excludeSpecialEl = this.shadowRoot.querySelector('.filter-exclude-special') as HTMLInputElement | null;

        if (minYieldEl) {
            minYieldEl.addEventListener('change', () => {
                const val = parseFloat(minYieldEl.value || '0');
                (this.config as any).p_min_yield = isNaN(val) ? 0 : val;
                this.setupChart();
            });
        }

        if (topNEl) {
            topNEl.value = String((this.config as any).p_top_n || 10);
            topNEl.addEventListener('change', () => {
                const v = topNEl.value;
                if (v === 'custom') {
                    if (topNCustomEl) {
                        topNCustomEl.classList.remove('hidden');
                        topNCustomEl.value = String((this.config as any).p_top_n || 10);
                        setTimeout(() => topNCustomEl.focus(), 0);
                    }
                } else {
                    (this.config as any).p_top_n = parseInt(v, 10) || 10;
                    this.setupChart();
                }
            });
        }

        if (topNCustomEl) {
            topNCustomEl.addEventListener('keydown', (ev: KeyboardEvent) => {
                if (ev.key === 'Enter') {
                    ev.preventDefault();
                    const nv = parseInt(topNCustomEl.value || '', 10);
                    if (!isNaN(nv) && nv > 0) {
                        (this.config as any).p_top_n = nv;
                        topNCustomEl.classList.add('hidden');
                        this.setupChart();
                    } else {
                        topNCustomEl.focus();
                        topNCustomEl.select();
                    }
                }
            });
            topNCustomEl.addEventListener('blur', () => {
                const nv = parseInt(topNCustomEl.value || '', 10);
                if (!isNaN(nv) && nv > 0) {
                    (this.config as any).p_top_n = nv;
                } else {
                    if (topNEl) topNEl.value = String((this.config as any).p_top_n || 10);
                }
                topNCustomEl.classList.add('hidden');
                this.setupChart();
            });
        }

        if (sortByEl) {
            sortByEl.value = String((this.config as any).p_sort_by || 'yield');
            sortByEl.addEventListener('change', () => {
                (this.config as any).p_sort_by = sortByEl.value;
                this.setupChart();
            });
        }

        if (excludeSpecialEl) {
            excludeSpecialEl.checked = !!(this.config as any).p_exclude_special_dividends;
            excludeSpecialEl.addEventListener('change', () => {
                (this.config as any).p_exclude_special_dividends = !!excludeSpecialEl.checked;
                this.setupChart();
            });
        }

        const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
        const filtersBtn = this.shadowRoot.querySelector('.optionsRow button') as HTMLButtonElement | null;
        if (filtersBtn && filtersBox) {
            filtersBtn.addEventListener('click', (ev: MouseEvent) => {
                ev.stopPropagation();
                filtersBox.classList.toggle('hidden');
            });

            filtersBox.addEventListener('click', (ev: MouseEvent) => ev.stopPropagation());
            filtersBox.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (minYieldEl) minYieldEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (topNEl) topNEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (topNCustomEl) topNCustomEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (sortByEl) sortByEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());
            if (excludeSpecialEl) excludeSpecialEl.addEventListener('pointerdown', (ev: PointerEvent) => ev.stopPropagation());

            this.outsideClickHandler = (ev: MouseEvent) => {
                try {
                    const path = (ev as any).composedPath ? (ev as any).composedPath() : (ev as any).path || [];
                    const clickedInside = Array.isArray(path) && path.some((node: any) => {
                        try {
                            return node && node.getRootNode && node.getRootNode() === this.shadowRoot;
                        } catch (e) {
                            return false;
                        }
                    });
                    if (!clickedInside) {
                        filtersBox.classList.add('hidden');
                    }
                } catch (e) {
                    filtersBox.classList.add('hidden');
                }
            };
            document.addEventListener('click', this.outsideClickHandler);
        }
    }

    private async attachStyles(): Promise<void> {
        try {
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }

    private async setupChart(): Promise<void> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) widget.classList.add('loading');
        try {
            const params: Record<string, string> = {};
            const cfg = this.config as any;
            if (typeof cfg.p_min_yield !== 'undefined') params.p_min_yield = String(cfg.p_min_yield);
            if (typeof cfg.p_top_n !== 'undefined') params.p_top_n = String(cfg.p_top_n);
            if (typeof cfg.p_sort_by !== 'undefined') params.p_sort_by = String(cfg.p_sort_by);
            if (typeof cfg.p_exclude_special_dividends !== 'undefined') params.p_exclude_special_dividends = cfg.p_exclude_special_dividends ? 'true' : 'false';
            const qs = Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
            const url = `${APIURL}/v1/discover/high-yield-dividend${qs ? `?${qs}` : ''}`;

            const response = await apiGet({
                method: 'GET',
                url,
                headers: { 'Content-Type': 'application/json' }
            });

            if (!response.ok) throw new Error("Failed to fetch data");
            const data = await response.json();
            const items = Array.isArray(data) ? data : (data && (data.data || data.items || data.results)) || [];
            this.currentData = items;
            const fromApi = (data as any)?.last_updated_at ?? (Array.isArray(items) ? items[0]?.last_updated_at : null);
            this.lastFetchedAt = fromApi ? new Date(fromApi) : new Date();
            this.updateDisplay();
            this.emit('dataUpdate', this.currentData);
        } catch (err) {
            console.error("Error fetching chart data:", err);
            this.currentData = [];
            this.lastFetchedAt = new Date();
            this.updateDisplay();
        } finally {
            if (widget) widget.classList.remove('loading');
        }
    }

    private formatLastUpdated(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'America/New_York',
        };
        return date.toLocaleString('en-US', options).replace(',', '').replace(/\//g, '-') + ' EST';
    }

    private updateLastUpdatedTooltip(): void {
        const lastUpdated = this.lastFetchedAt ? this.formatLastUpdated(this.lastFetchedAt) : 'N/A';
        const tooltip = this.shadowRoot.querySelector('#lastUpdatedTooltip tooltip strong');
        if (tooltip) tooltip.innerHTML = lastUpdated.replace(' ', '<br>');
    }

    private updateDisplay(): void {
        this.updateLastUpdatedTooltip();
        if (!this.currentData) {
            return;
        }
        this.renderAnalystRating();
    }

    private renderAnalystRating(): void {
        const container = this.shadowRoot.querySelector('#topIndexContainer');
        if (!container) return;

        const items = Array.isArray(this.currentData)
            ? this.currentData
            : (this.currentData && (this.currentData.data || this.currentData.items)) || [];
                const hasData = Array.isArray(items) && items.length > 0;

    // ❌ No data case
    if (!hasData) {
        container.removeAttribute('data-testing-id');
        container.innerHTML = getNoDataHTML();
        return;
    }

    // ✅ Data exists → attribute ON yahan lagao
    container.setAttribute('data-testing-id', 'high-yield-dividend-chartdv');
        if (!Array.isArray(items) || items.length === 0) {
            container.innerHTML = getNoDataHTML();
            return;
        }

        let html = `
            <div class="highYieldMain" data-testing-id="high-yield-main">
                <div class="inner" data-testing-id="high-yield-inner">
        `;
        
        for (let idx = 0; idx < items.length; idx++) {
            const item = items[idx];
            const badge = `<span class="badge" data-testing-id="rank-badge">#${idx + 1}</span>`;
            const yieldVal = (typeof item.yield === 'number') ? `${item.yield}%` : item.yield || '';
            
            html += `
                <div class="item" 
                     data-testing-id="dividend-item-${idx}" 
                     data-index="${idx}"
                     data-symbol="${item.symbol || ''}"
                     data-frequency="${item.frequency || ''}"
                     data-payment-date="${item.payment_date || ''}"
                     data-dividend="${item.adj_dividend || 0}"
                     data-yield="${item.yield || 0}">
                    <div class="mainRow rowitm">
                        <div class="colItm">
                            <h4 data-testing-id="item-symbol">${item.symbol}</h4>
                            <p data-testing-id="item-frequency">${item.frequency}</p>
                        </div>
                        <div class="colItm">${badge}</div>
                    </div>
                    <div class="subRow rowitm">
                        <div class="colItm">
                            <p data-testing-id="item-payment-label">Payment Date <strong data-testing-id="item-payment-date">${item.payment_date}</strong></p>
                        </div>
                        <div class="colItm text-center">
                            <p data-testing-id="item-dividend-label">Dividend <strong data-testing-id="item-dividend-amount">$${item.adj_dividend}</strong></p>
                        </div>
                        <div class="colItm text-right">
                            <p data-testing-id="item-yield-label">Yield <strong class="text-green" data-testing-id="item-yield-value">${yieldVal}</strong></p>
                        </div>
                    </div>
                </div>
            `;
        }
        
        html += `
                </div>
            </div>
        `;

        container.innerHTML = html;
    }

    private changeSymbol(stockId: string, stock: any = null): void {
        changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any) => this.setupChart(), (type: any, data: any) => this.emit(type, data));
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }
    public setSymbol(symbol: string): void {
        this.changeSymbol(symbol);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        if (dropdown) dropdown.value = symbol;
    }
    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
      if (!this.shadowRoot) return;
    
      this.config.theme = toggleWidgetTheme(
        this.shadowRoot,
        theme
      ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
    
      this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        if (this.outsideClickHandler) {
            document.removeEventListener('click', this.outsideClickHandler);
            this.outsideClickHandler = null;
        }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
    private getTitleIconSvg(): string {
      return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
    }

}

declare global { interface Window { TraderverseHighYieldDividend: typeof TraderverseHighYieldDividend; } }
if (typeof window !== 'undefined') { window.TraderverseHighYieldDividend = TraderverseHighYieldDividend; }